<script lang="ts">
    import { onMount } from 'svelte'
    import { navigateTo } from 'yrv'
    import { NPS } from '../../modules/toolsApi/nps/nps/nps'
    import { NPSRepository } from '../../modules/toolsApi/nps/nps/nps.repository'
    import { NPSService } from '../../modules/toolsApi/nps/nps/nps.service'
    import type { CreateReviewDto } from '../../modules/toolsApi/nps/reviews/dto/create-review.dto'
    import { Review } from '../../modules/toolsApi/nps/reviews/review'
    import { ReviewType } from '../../modules/toolsApi/nps/reviews/reviews.enum'
    import { ReviewsRepository } from '../../modules/toolsApi/nps/reviews/reviews.repository'
    import { ReviewsService } from '../../modules/toolsApi/nps/reviews/reviews.service'

    let npsR = new NPSRepository()
    let npsS = new NPSService(npsR)

    let reviewR = new ReviewsRepository()
    let reviewS = new ReviewsService(reviewR)

    let step = 1
    let rating = -1
    let text = ''
    let nps: NPS = new NPS()
    let review: Review = new Review()
    let companyId = null
    let personId = null
    let googleURL = 'https://search.google.com/local/writereview?placeid='

    onMount(async () => {
        await load()
    })

    async function load() {
        //todo
        const urlParams = new URLSearchParams(window.location.search)
        companyId = urlParams.get('id')
        personId = urlParams.get('u')
        if (!companyId || !personId) {
            step = 9
            return
        }
        window.api.users.statistics.tickPublicOnce(companyId, 'pub.nps.open')
        nps = await npsS.getNPSPublic(companyId)
    }

    async function send() {
        if (rating < 0) {
            alert('Escolha uma opção.')
            return
        }
        let dto: CreateReviewDto = {
            companyId: companyId,
            feedback: false,
            personId: personId,
            rating: rating,
            text: text,
            type: ReviewType.nps,
        }
        review = await reviewS.create(dto)
        window.api.users.statistics.tickPublic(companyId, 'pub.nps.create')
        if (rating === 10 && nps.googleOn && nps.googlePlaceId && !review.sendToGoogle) {
            step = 2 // google
        } else {
            step = 3 // thanks
        }
    }

    async function sendNo() {
        step = 3 // thanks
    }

    async function sendYes() {
        await reviewS.setSentToGoogle(review.reviewId)
        location.href = googleURL + nps.googlePlaceId
    }
</script>

<div class="root">
    {#if step === 1}
        <div class="form">
            <label for="">Em uma escala de 0 a 10, o quanto você indicaria nossa empresa para um amigo?</label>
            <select class="form-select" name="" id="" bind:value={rating}>
                <option value={-1}>Escolha</option>
                {#each [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as number}
                    <option value={number}>{number}</option>
                {/each}
            </select>
            {#if rating >= 0}
                {#if rating < 10}
                    <label for="">(opcional) O que podemos fazer para merecer de você uma nota maior no futuro?</label>
                    <textarea name="" id="" rows="4" bind:value={text} />
                {/if}
                <div class="d-flex justify-content-end">
                    <button on:click={send} class="btn btn-primary">&nbsp;&nbsp;&nbsp;Enviar&nbsp;&nbsp;&nbsp;</button>
                </div>
            {/if}
        </div>
    {/if}
    {#if step === 2}
        <label class="text-center mt-5 mb-4" for="">Você permite enviar essa avaliação ao Google?</label>
        <div class="text-center">
            <button on:click={sendNo} class="btn btn-secondary"
                >&nbsp;&nbsp;&nbsp;&nbsp;Não&nbsp;&nbsp;&nbsp;&nbsp;</button
            >&nbsp;&nbsp;&nbsp;&nbsp;
            <button on:click={sendYes} class="btn btn-primary"
                >&nbsp;&nbsp;&nbsp;&nbsp;Sim&nbsp;&nbsp;&nbsp;&nbsp;</button
            >
        </div>
    {/if}
    {#if step === 3}
        <div class="text-center">Muito obrigado por sua contribuição.</div>
    {/if}
    {#if step === 4}
        <div class="text-center">
            Você já respondeu este tópico recentemente.<br />
            Obrigado pelo interesse.
        </div>
    {/if}
    {#if step === 9}
        <div class="text-center">Indisponível no momento.</div>
    {/if}
</div>

<style>
    .root {
        max-width: 970px;
        margin: 0 auto;
        margin-top: 64px;
        font-size: 20px;
        font-weight: 400;
        padding: 16px;
    }

    .form {
        display: flex;
        flex-direction: column;
    }
    label {
        margin-bottom: 8px;
    }
    select,
    textarea {
        margin-bottom: 16px;
    }
</style>
